import { State } from "src/state";

export const getAlertBannerState = (state: State) => state.alertBanner;



// WEBPACK FOOTER //
// ./src/shared/alertBanner/selector.ts